import { createContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useOffer from '../offer/useOffer';

type Props = {
  children: React.ReactNode;
};

type IronDomeContextValues = {
  offers: any[];
  selectedMembers: any[];
  loading: boolean;
  setSelectedMembers: React.Dispatch<React.SetStateAction<any[]>>;
  setOffers: React.Dispatch<React.SetStateAction<any[]>>;
  searchOffers: (name: string) => void;
  focusOfferId: string;
};

export const IronDomeContext = createContext<IronDomeContextValues>({
  offers: [],
  selectedMembers: [],
  loading: false,
  setSelectedMembers: {} as any,
  setOffers: {} as any,
  searchOffers: () => {},
  focusOfferId: '',
});

const IronDomeProvider = ({ children }: Props) => {
  const [offers, setOffers] = useState<any[]>([]);
  const [selectedMembers, setSelectedMembers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const offerClient = useOffer();

  // Set when opened from the offers table (/iron-dome?offerId=...).
  const [searchParams] = useSearchParams();
  const focusOfferId = searchParams.get('offerId') ?? '';

  const initOffers = (name = '') => {
    const api = offerClient.getAllOffersForIronDome();

    (async () => {
      setLoading(true);
      try {
        const res = await api.call(name, name ? '' : focusOfferId);
        setOffers(res);
      } catch (error) {}
      setLoading(false);
    })();

    return api.abort;
  };

  const searchOffers = (name: string) => {
    initOffers(name);
  };

  const values: IronDomeContextValues = {
    offers,
    selectedMembers,
    loading,
    setSelectedMembers,
    setOffers,
    searchOffers,
    focusOfferId,
  };

  useEffect(() => {
    return initOffers();
  }, []);

  return (
    <IronDomeContext.Provider value={values}>
      {children}
    </IronDomeContext.Provider>
  );
};

export default IronDomeProvider;
